// Las tres tablas del monitoreo comparten fila en un grid de 3 columnas, así que cada una dispone
// de un tercio del ancho: sin bajar el mínimo de `Table` (600px) siempre mostrarían scroll
// horizontal.
export const MONITORING_TABLE_MIN_WIDTH = 320;
